import { render, staticRenderFns } from "./PostHistory.vue?vue&type=template&id=d50d4b78&scoped=true"
import script from "./PostHistory.vue?vue&type=script&lang=js"
export * from "./PostHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50d4b78",
  null
  
)

export default component.exports